export default __webpack_public_path__ + "static/attribute_dont-dark-9d593efa4bd3b54d764919da8bf5bd7b.png";